import { render, staticRenderFns } from "./email-view.vue?vue&type=template&id=4658703e&scoped=true"
import script from "./email-view.vue?vue&type=script&lang=js"
export * from "./email-view.vue?vue&type=script&lang=js"
import style0 from "./email-view.vue?vue&type=style&index=0&id=4658703e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4658703e",
  null
  
)

export default component.exports